<template>
  <div :class="outerClasses">
    <component :is="as" :class="wrapperClasses">
      <slot />
    </component>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  as: {
    type: String,
    default: "div",
  },
  maxWidthClass: {
    type: String,
    default: "max-w-7xl",
  },
  paddingClass: {
    type: String,
    default: "px-5 md:px-3",
  },
  outerClass: {
    type: String,
    default: "",
  },
  className: {
    type: String,
    default: "",
  },
});

const outerClasses = computed(() => {
  return ["w-full", props.outerClass];
});

const wrapperClasses = computed(() => {
  return [
    "mx-auto",
    "w-full",
    // "overflow-x-hidden",
    props.maxWidthClass,
    props.paddingClass,
    props.className,
  ];
});
</script>
